'use client';
import { useState, useEffect } from 'react';
import { isBrowser } from '@s7/platform';
import { isNumber } from '@s7/utils';
import { useWindowEvent } from '../useWindowEvent/useWindowEvent.js';

var getScrollPosition = function() {
    return isBrowser() ? {
        x: window.pageXOffset,
        y: window.pageYOffset
    } : {
        x: 0,
        y: 0
    };
};
var scrollTo = function(param) {
    var x = param.x, y = param.y;
    if (isBrowser()) {
        var scrollOptions = {
            behavior: "smooth"
        };
        if (isNumber(x)) {
            scrollOptions.left = x;
        }
        if (isNumber(y)) {
            scrollOptions.top = y;
        }
        window.scrollTo(scrollOptions);
    }
};
var useWindowScroll = function() {
    var _useState = useState({
        x: 0,
        y: 0
    }), position = _useState[0], setPosition = _useState[1];
    useWindowEvent("scroll", function() {
        return setPosition(getScrollPosition());
    });
    useWindowEvent("resize", function() {
        return setPosition(getScrollPosition());
    });
    useEffect(function() {
        setPosition(getScrollPosition());
    }, []);
    return [
        position,
        scrollTo
    ];
};

export { scrollTo, useWindowScroll };
